import { httpClient } from './httpClient'

interface EditBatchStScheduledExerciseSettingPayload {
  settings: {
    scheduledExerciseId: number
    settingTextId: string
    newValue: number
  }[]
}

export async function editBatchStScheduledExerciseSetting ({
  editStScheduledExerciseSettingRequestPayload
}: {
  editStScheduledExerciseSettingRequestPayload: EditBatchStScheduledExerciseSettingPayload
}) {
  const { settings } = editStScheduledExerciseSettingRequestPayload

  try {
    const url = import.meta.env.VITE_BATCH_EDIT_SCHEDULED_TPL_EXERCISE_SETTING_ENDPOINT

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'PUT',
      data: { settings },
      withCredentials: true
    })

    return response?.data
  } catch (error) {
    console.error('editBatchStScheduledExerciseSetting - Error: ', error)
    throw error
  }
}
